// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyState_wrap__XpKDO","icon":"EmptyState_icon__CfxoA","title":"EmptyState_title__V7tXM","description":"EmptyState_description__JmPyB","action":"EmptyState_action__OMA2+"};